var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 46,
    viewBox: "0 0 101 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.636719,
    y: 1.04199,
    width: 99,
    height: 44,
    rx: 1.5,
    fill: "white",
    stroke: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 29,
    width: 3,
    height: 2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9922 30.2139C44.9922 30.6226 45.2987 30.9292 45.7075 30.9292C46.1163 30.9292 46.4228 30.6226 46.4228 30.2139C46.4228 29.8051 46.1163 29.4985 45.7075 29.4985C45.2987 29.4985 44.9922 29.8051 44.9922 30.2139Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3727 29.4988H44.9932V30.8784H46.3727V29.4988Z",
    fill: "url(#paint0_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 29,
    width: 2,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2422 30.3674C47.2422 30.7762 47.5488 31.0828 47.9575 31.0828C48.3663 31.0828 48.6729 30.7762 48.6729 30.3674C48.6729 29.9587 48.3663 29.6521 47.9575 29.6521C47.5488 29.601 47.2422 29.9587 47.2422 30.3674Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.724 29.6011H47.2422V31.0828H48.724V29.6011Z",
    fill: "url(#paint1_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 30,
    width: 2,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3369 31.3382C49.3369 31.7469 49.6946 32.1046 50.1033 32.1046C50.5121 32.1046 50.8698 31.7469 50.8698 31.3382C50.8698 30.9294 50.5121 30.5718 50.1033 30.5718C49.6946 30.5207 49.3369 30.8783 49.3369 31.3382Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8698 30.5208H49.3369V32.0536H50.8698V30.5208Z",
    fill: "url(#paint2_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 31,
    width: 2,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3291 32.7179C51.3291 33.1778 51.6868 33.5354 52.1466 33.5354C52.6065 33.5354 52.9641 33.1778 52.9641 32.7179C52.9641 32.258 52.6065 31.9004 52.1466 31.9004C51.7379 31.9004 51.3291 32.258 51.3291 32.7179Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9641 31.9004H51.3291V33.5354H52.9641V31.9004Z",
    fill: "url(#paint3_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 31,
    width: 3,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.833 32.6667C53.833 33.1266 54.1907 33.5353 54.7016 33.5353C55.2126 33.5353 55.5703 33.1777 55.5703 32.6667C55.5703 32.2069 55.2126 31.7981 54.7016 31.7981C54.1907 31.7981 53.833 32.2069 53.833 32.6667Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5191 31.7981H53.833V33.4842H55.5191V31.7981Z",
    fill: "url(#paint4_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 30,
    width: 2,
    height: 3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.082 31.4406C56.082 31.9516 56.4908 32.3093 56.9506 32.3093C57.4616 32.3093 57.8192 31.9005 57.8192 31.4406C57.8192 30.9297 57.4105 30.572 56.9506 30.572C56.4908 30.572 56.082 30.9808 56.082 31.4406Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8704 30.572H56.082V32.3603H57.8704V30.572Z",
    fill: "url(#paint5_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 29,
    width: 3,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6348 30.4182C58.6348 30.9292 59.0435 31.338 59.5545 31.338C60.0654 31.338 60.4742 30.9292 60.4742 30.4182C60.4742 29.9073 60.0654 29.4985 59.5545 29.4985C59.0435 29.4985 58.6348 29.9073 58.6348 30.4182Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4752 29.4988H58.6357V31.3382H60.4752V29.4988Z",
    fill: "url(#paint6_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 30,
    width: 3,
    height: 3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2402 31.1852C61.2402 31.6961 61.7001 32.156 62.2111 32.156C62.722 32.156 63.1818 31.6961 63.1818 31.1852C63.1818 30.6742 62.722 30.2144 62.2111 30.2144C61.7001 30.2144 61.2402 30.6231 61.2402 31.1852Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1818 30.2144H61.2402V32.156H63.1818V30.2144Z",
    fill: "url(#paint7_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 31,
    width: 3,
    height: 3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6943 32.5646C63.6943 33.1267 64.1542 33.5865 64.7162 33.5865C65.2783 33.5865 65.7381 33.1267 65.7381 32.5646C65.7381 32.0026 65.2783 31.5427 64.7162 31.5427C64.1542 31.5938 63.6943 32.0026 63.6943 32.5646Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6871 31.5938H63.6943V33.5865H65.6871V31.5938Z",
    fill: "url(#paint8_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 30,
    width: 3,
    height: 3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2988 31.2875C66.2988 31.8495 66.7587 32.3094 67.3207 32.3094C67.8828 32.3094 68.3426 31.8495 68.3426 31.2875C68.3426 30.7255 67.8828 30.2656 67.3207 30.2656C66.7587 30.2145 66.2988 30.6744 66.2988 31.2875Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3937 30.2144H66.2988V32.3093H68.3937V30.2144Z",
    fill: "url(#paint9_linear_881_2383)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_881_2383",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 27,
    width: 3,
    height: 3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4248 28.5281C67.4248 29.1412 67.9358 29.6011 68.4978 29.6011C69.111 29.6011 69.5708 29.0901 69.5708 28.5281C69.5708 27.9149 69.0599 27.4551 68.4978 27.4551C67.9358 27.4551 67.4248 27.9149 67.4248 28.5281Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_881_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5708 27.4551H67.4248V29.6522H69.5708V27.4551Z",
    fill: "url(#paint10_linear_881_2383)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73007 24.6447C5.18993 24.9512 6.00744 25.2578 6.82496 25.2578C8.00015 25.2578 8.51109 24.6958 8.51109 23.9804C8.51109 23.214 8.05123 22.8052 6.87604 22.3965C5.2921 21.8344 4.57676 20.9658 4.57676 19.9439C4.57676 18.5133 5.70087 17.3892 7.59139 17.3892C8.46 17.3892 9.27753 17.6446 9.73739 17.9512L9.32863 19.1264C8.97097 18.922 8.35782 18.6155 7.5403 18.6155C6.62059 18.6155 6.05853 19.1775 6.05853 19.7906C6.05853 20.506 6.56948 20.8636 7.74466 21.2724C9.27752 21.8344 10.0439 22.6009 10.0439 23.9293C10.0439 25.4622 8.86878 26.5863 6.77388 26.5863C5.80307 26.5863 4.93443 26.3308 4.32129 25.9731L4.73007 24.6447Z",
    fill: "#7F8081"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3214 25.9222C17.9126 26.1266 16.9929 26.4331 15.8177 26.4331C13.1607 26.4331 11.4746 24.6448 11.4746 21.9368C11.4746 19.2287 13.314 17.2871 16.1754 17.2871C17.0951 17.2871 17.9637 17.5426 18.3724 17.747L18.0148 18.9732C17.6571 18.7689 17.044 18.5645 16.1754 18.5645C14.1827 18.5645 13.0586 20.0462 13.0586 21.8857C13.0586 23.9295 14.3359 25.1557 16.0732 25.1557C16.9929 25.1557 17.5549 24.9003 18.0148 24.747L18.3214 25.9222Z",
    fill: "#7F8081"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.081 21.9367C21.081 23.8272 22.2051 25.309 23.738 25.309C25.2708 25.309 26.3949 23.8783 26.3949 21.8856C26.3949 20.4038 25.6285 18.5133 23.7891 18.5133C21.8986 18.5133 21.081 20.2506 21.081 21.9367ZM28.03 21.8345C28.03 25.0535 25.7818 26.4841 23.6869 26.4841C21.3365 26.4841 19.4971 24.7469 19.4971 21.9878C19.4971 19.0754 21.3876 17.3381 23.8402 17.3381C26.2927 17.3381 28.03 19.1265 28.03 21.8345Z",
    fill: "#7F8081"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0228 20.4549C30.0228 19.433 30.0228 18.5133 29.9717 17.7469H31.3513L31.4023 19.4841H31.4534C31.8622 18.3089 32.833 17.5425 33.8549 17.5425C34.0593 17.5425 34.1615 17.5425 34.3148 17.5936V19.0753C34.1615 19.0242 34.0082 19.0242 33.7527 19.0242C32.6286 19.0242 31.8622 19.8929 31.6067 21.068C31.5556 21.2724 31.5556 21.5279 31.5556 21.8345V26.4841H29.9717V20.4549H30.0228Z",
    fill: "#7F8081"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3147 21.0681C41.3147 20.0462 40.9059 18.4623 39.1176 18.4623C37.4825 18.4623 36.8183 19.944 36.665 21.0681H41.3147ZM36.6139 22.1922C36.665 24.3382 38.0446 25.2068 39.6285 25.2068C40.7526 25.2068 41.468 25.0025 42.03 24.747L42.2855 25.8711C41.7234 26.1265 40.7526 26.4331 39.3731 26.4331C36.665 26.4331 35.0811 24.6448 35.0811 21.9878C35.0811 19.3309 36.6139 17.2871 39.1687 17.2871C42.03 17.2871 42.7964 19.7908 42.7964 21.4258C42.7964 21.7324 42.7453 21.9879 42.7453 22.1922H36.6139Z",
    fill: "#7F8081"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4895 17.9513H70.1318V17.8491H71.1026V17.9513H70.6939V19.1265H70.4895V17.9513Z",
    fill: "#939639"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3289 18.5644C72.3289 18.3601 72.3289 18.1557 72.3289 18.0024C72.2778 18.1557 72.2267 18.309 72.1756 18.5134L71.9712 19.1265H71.8179L71.6135 18.5134C71.5624 18.309 71.5113 18.1557 71.4603 18.0024C71.4603 18.1557 71.4603 18.3601 71.4603 18.5644L71.4092 19.1265H71.2559L71.3581 17.8491H71.5624L71.7668 18.4623C71.8179 18.6155 71.869 18.7688 71.9201 18.9221C71.9712 18.7688 72.0223 18.6666 72.0734 18.4623L72.3289 17.8491H72.5332L72.6354 19.1265H72.4822L72.3289 18.5644Z",
    fill: "#939639"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9421 26.4841V19.0242H43.7158V17.8491H44.9421V17.4403C44.9421 16.214 45.1976 15.141 45.964 14.4257C46.5771 13.8636 47.3436 13.6082 48.0589 13.6082C48.6209 13.6082 49.0808 13.7103 49.3874 13.8636L49.183 15.0899C48.9275 14.9877 48.621 14.8855 48.1611 14.8855C46.8326 14.8855 46.4749 16.0607 46.4749 17.3892V17.8491H48.5699V19.0242H46.4749V26.4841H44.9421Z",
    fill: "#939639"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1982 13.7615H50.6143V26.433H52.1982V13.7615Z",
    fill: "#939639"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4534 21.1193C59.4534 20.0974 59.0446 18.5645 57.2563 18.5645C55.6723 18.5645 54.957 20.0463 54.8548 21.1193H59.4534ZM54.8548 22.2434C54.9059 24.3894 56.2344 25.258 57.8183 25.258C58.9424 25.258 59.6067 25.0536 60.2198 24.7981L60.4753 25.9222C59.9132 26.1777 58.9935 26.4843 57.614 26.4843C54.957 26.4843 53.373 24.6959 53.373 22.0901C53.373 19.4842 54.9059 17.4404 57.4096 17.4404C60.2198 17.4404 60.9862 19.9441 60.9862 21.528C60.9862 21.8346 60.9351 22.0901 60.9351 22.2434H54.8548Z",
    fill: "#939639"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.592 17.7981L64.8183 19.6375C65.1249 20.0974 65.4314 20.5572 65.6869 21.0682H65.738C66.0446 20.5572 66.3 20.0974 66.6066 19.6375L67.8329 17.7981H69.519L66.5555 21.9879L69.5701 26.4332H67.7818L66.5044 24.4916C66.1468 23.9806 65.8913 23.5207 65.5847 23.0098H65.5336C65.2271 23.5207 64.9205 23.9806 64.6139 24.4916L63.3876 26.4332H61.6504L64.7161 22.039L61.8037 17.7981H63.592Z",
    fill: "#939639"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7599 23.6229C94.7599 29.2944 90.1614 33.893 84.4898 33.893C78.8183 33.893 74.2197 29.2944 74.2197 23.6229C74.2197 17.9513 78.8183 13.3528 84.4898 13.3528C90.2125 13.4039 94.7599 18.0024 94.7599 23.6229Z",
    fill: "#923854"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.205 21.7324V26.0755H77.7451V21.2214H79.278L83.6211 25.5645V21.2214H84.132V26.0755H82.3437L78.205 21.7324Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.198 26.0755C86.9936 26.0755 86.7892 26.0244 86.5849 25.9733C86.3805 25.9222 86.2272 25.8201 86.0228 25.7179C85.8696 25.6157 85.7163 25.5135 85.563 25.3602C85.4097 25.2069 85.3075 25.0536 85.2053 24.8492C85.1031 24.696 85.052 24.4916 84.9499 24.2872C84.8988 24.0828 84.8477 23.8784 84.8477 23.623C84.8477 23.4186 84.8988 23.1631 84.9499 22.9587C85.0009 22.7544 85.1031 22.55 85.2053 22.3967C85.3075 22.1923 85.4097 22.039 85.563 21.8857C85.7163 21.7325 85.8696 21.6303 86.0228 21.5281C86.1761 21.4259 86.3805 21.3237 86.5849 21.2726C86.7892 21.2215 86.9936 21.1704 87.198 21.1704H91.3367V21.6303H88.1177C87.8622 21.6303 87.6068 21.6814 87.4024 21.7835C87.198 21.8857 86.9936 22.039 86.7893 22.1923C86.636 22.3456 86.4827 22.6011 86.3805 22.8054C86.2783 23.0609 86.2272 23.3164 86.2272 23.5719C86.2272 23.8273 86.2783 24.0828 86.3805 24.3383C86.4827 24.5938 86.636 24.7982 86.7893 24.9514C86.9425 25.1047 87.1469 25.258 87.4024 25.3602C87.6068 25.4624 87.8622 25.5135 88.1177 25.5135H91.3367V25.9733H87.198V26.0755Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34349 29.8564C5.2924 29.7031 5.19021 29.5498 4.93474 29.5498C4.62817 29.5498 4.4749 29.7031 4.4749 30.0608C4.4749 30.3163 4.57707 30.5206 4.93474 30.5206C5.13912 30.5206 5.2924 30.4184 5.34349 30.163H5.54788C5.49679 30.4184 5.2924 30.6739 4.93474 30.6739C4.62817 30.6739 4.27051 30.5206 4.27051 30.0097C4.27051 29.652 4.47488 29.3455 4.93474 29.3455C5.19021 29.3455 5.49679 29.4476 5.54788 29.8053H5.34349V29.8564Z",
    fill: "#7F8081"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67208 29.8564C6.41661 29.8564 6.31441 30.0097 6.31441 30.2141C6.31441 30.3674 6.41661 30.5717 6.67208 30.5717C6.92756 30.5717 7.02976 30.4185 7.02976 30.2141C7.02976 30.0097 6.92756 29.8564 6.67208 29.8564ZM6.67208 29.7031C7.02975 29.7031 7.18303 29.9075 7.18303 30.163C7.18303 30.4185 7.02975 30.6228 6.67208 30.6228C6.31442 30.6228 6.16113 30.4185 6.16113 30.163C6.16113 29.9075 6.31442 29.7031 6.67208 29.7031Z",
    fill: "#7F8081"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84668 29.7542H7.99996V29.9075C8.10215 29.7542 8.20436 29.7031 8.30655 29.7031C8.35764 29.7031 8.35762 29.7031 8.40871 29.7031V29.9075C8.35762 29.9075 8.35764 29.9075 8.30655 29.9075C8.15326 29.9075 7.99996 30.0097 7.99996 30.2141V30.6739H7.84668V29.7542Z",
    fill: "#7F8081"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48263 29.8564C9.22716 29.8564 9.12496 30.0097 9.12496 30.2141C9.12496 30.3674 9.22716 30.5717 9.48263 30.5717C9.73811 30.5717 9.8403 30.4185 9.8403 30.2141C9.8403 30.0097 9.73811 29.8564 9.48263 29.8564ZM9.48263 29.7031C9.8403 29.7031 9.99358 29.9075 9.99358 30.163C9.99358 30.4185 9.8403 30.6228 9.48263 30.6228C9.12496 30.6228 8.97168 30.4185 8.97168 30.163C8.97168 29.9075 9.17606 29.7031 9.48263 29.7031Z",
    fill: "#7F8081"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6572 29.7544H10.8105V29.9077C10.9127 29.8055 11.0149 29.7544 11.1682 29.7544C11.3726 29.7544 11.5258 29.8566 11.5258 30.061V30.6741H11.3726V30.1121C11.3726 29.9588 11.2704 29.9077 11.1171 29.9077C10.9638 29.9077 10.8105 30.0099 10.8105 30.1631V30.6741H10.6572V29.7544Z",
    fill: "#7F8081"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9569 30.163C12.9569 30.2141 12.9058 30.2141 12.8036 30.2141H12.5992C12.4459 30.2141 12.3948 30.2652 12.3948 30.3674C12.3948 30.4696 12.497 30.5206 12.5992 30.5206C12.8036 30.5206 12.9569 30.4185 12.9569 30.2652V30.163ZM12.2415 30.0097C12.2415 29.8053 12.3948 29.7031 12.7014 29.7031C12.9058 29.7031 13.1101 29.7542 13.1101 29.9586V30.4185C13.1101 30.4695 13.1102 30.5206 13.1612 30.5206H13.2123V30.6228C13.1612 30.6228 13.1101 30.6228 13.0591 30.6228C12.9569 30.6228 12.9058 30.6228 12.9058 30.5206C12.8547 30.6228 12.6503 30.6739 12.5481 30.6739C12.2415 30.6739 12.1904 30.5206 12.1904 30.4185C12.1904 30.2652 12.2926 30.163 12.5992 30.163H12.8036C12.9058 30.163 12.9569 30.1119 12.9569 30.0608C12.9569 29.9586 12.8547 29.9075 12.7014 29.9075C12.5481 29.9075 12.4459 29.9586 12.4459 30.0608H12.2415V30.0097Z",
    fill: "#7F8081"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.876 29.7542H14.0293V29.9075C14.1314 29.7542 14.2337 29.7031 14.3358 29.7031C14.3869 29.7031 14.3869 29.7031 14.438 29.7031V29.9075C14.3869 29.9075 14.3869 29.9075 14.3358 29.9075C14.1826 29.9075 14.0293 30.0097 14.0293 30.2141V30.6739H13.876V29.7542Z",
    fill: "#7F8081"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7156 29.7542H15.92L15.4602 30.8272C15.358 31.0316 15.3069 31.0316 15.1536 31.0316C15.1025 31.0316 15.0514 31.0316 15.0003 31.0316V30.8783C15.0514 30.8783 15.0514 30.8783 15.1025 30.8783C15.2047 30.8783 15.2558 30.8783 15.3069 30.725L15.358 30.6228L14.9492 29.7031H15.1536L15.4602 30.4185L15.7156 29.7542Z",
    fill: "#7F8081"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2199 30.4695C18.5265 30.4695 18.5776 30.214 18.5776 30.0096C18.5776 29.8053 18.5265 29.5498 18.1688 29.5498H17.7601V30.4695H18.2199ZM17.5557 29.3965H18.1688C18.5265 29.3965 18.6798 29.652 18.6798 30.0096C18.6798 30.3673 18.5265 30.6228 18.1688 30.6228H17.5557V29.3965Z",
    fill: "#7F8081"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 29.7542H19.5478V30.6739H19.3945V29.7542ZM19.3945 29.3965H19.5478V29.6009H19.3945V29.3965Z",
    fill: "#7F8081"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.416 29.3965H20.2627V30.6228H20.416V29.3965Z",
    fill: "#7F8081"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7961 30.163C21.745 30.2141 21.745 30.2141 21.6428 30.2141H21.4384C21.2851 30.2141 21.234 30.2652 21.234 30.3674C21.234 30.4696 21.3362 30.5206 21.4384 30.5206C21.6428 30.5206 21.7961 30.4185 21.7961 30.2652V30.163ZM21.1318 30.0097C21.1318 29.8053 21.2851 29.7031 21.5917 29.7031C21.7961 29.7031 22.0005 29.7542 22.0005 29.9586V30.4185C22.0005 30.4695 22.0005 30.5206 22.1027 30.5206H22.1537V30.6228C22.1026 30.6228 22.0516 30.6228 22.0005 30.6228C21.8983 30.6228 21.8472 30.6228 21.8472 30.5206C21.7961 30.6228 21.5917 30.6739 21.4895 30.6739C21.1829 30.6739 21.1318 30.5206 21.1318 30.4185C21.1318 30.2652 21.234 30.163 21.5406 30.163H21.745C21.8472 30.163 21.8983 30.1119 21.8983 30.0608C21.8983 29.9586 21.7961 29.9075 21.6428 29.9075C21.4895 29.9075 21.3873 29.9586 21.3873 30.0608H21.1318V30.0097Z",
    fill: "#7F8081"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7672 29.4478H22.9205V29.7032H23.1759V29.8565H22.9205V30.4186C22.9205 30.4697 22.9716 30.5208 23.0738 30.5208C23.1248 30.5208 23.1759 30.5208 23.1759 30.5208V30.674C23.1249 30.674 23.0737 30.674 22.9716 30.674C22.8183 30.674 22.7161 30.5718 22.7161 30.4697V29.9076H22.5117V29.7543H22.7161V29.4478H22.7672Z",
    fill: "#7F8081"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5044 30.163C24.4533 30.2141 24.4533 30.2141 24.3511 30.2141H24.1467C23.9934 30.2141 23.9423 30.2652 23.9423 30.3674C23.9423 30.4696 24.0445 30.5206 24.1467 30.5206C24.3511 30.5206 24.5044 30.4185 24.5044 30.2652V30.163ZM23.7891 30.0097C23.7891 29.8053 23.9423 29.7031 24.2489 29.7031C24.4533 29.7031 24.6577 29.7542 24.6577 29.9586V30.4185C24.6577 30.4695 24.6577 30.5206 24.7599 30.5206H24.811V30.6228C24.7599 30.6228 24.7088 30.6228 24.6577 30.6228C24.5555 30.6228 24.5044 30.6228 24.5044 30.5206C24.4533 30.6228 24.2489 30.6739 24.1467 30.6739C23.8402 30.6739 23.7891 30.5206 23.7891 30.4185C23.7891 30.2652 23.8912 30.163 24.1978 30.163H24.4022C24.5044 30.163 24.5555 30.1119 24.5555 30.0608C24.5555 29.9586 24.4533 29.9075 24.3 29.9075C24.1467 29.9075 24.0445 29.9586 24.0445 30.0608H23.7891V30.0097Z",
    fill: "#7F8081"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4752 29.4478H25.6285V29.7032H25.884V29.8565H25.6285V30.4186C25.6285 30.4697 25.6796 30.5208 25.7818 30.5208C25.8329 30.5208 25.884 30.5208 25.884 30.5208V30.674C25.8329 30.674 25.7818 30.674 25.6796 30.674C25.5263 30.674 25.4241 30.5718 25.4241 30.4697V29.9076H25.2197V29.7543H25.4241V29.4478H25.4752Z",
    fill: "#7F8081"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4971 29.7542H26.6503V30.6739H26.4971V29.7542ZM26.4971 29.3965H26.6503V29.6009H26.4971V29.3965Z",
    fill: "#7F8081"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8761 29.8564C27.6207 29.8564 27.5185 30.0097 27.5185 30.2141C27.5185 30.3674 27.6207 30.5717 27.8761 30.5717C28.1316 30.5717 28.2338 30.4185 28.2338 30.2141C28.1827 30.0097 28.1316 29.8564 27.8761 29.8564ZM27.8761 29.7031C28.2338 29.7031 28.3871 29.9075 28.3871 30.163C28.3871 30.4185 28.2338 30.6228 27.8761 30.6228C27.5185 30.6228 27.3652 30.4185 27.3652 30.163C27.3141 29.9075 27.5185 29.7031 27.8761 29.7031Z",
    fill: "#7F8081"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0518 29.7544H29.205V29.9077C29.3072 29.8055 29.4094 29.7544 29.5627 29.7544C29.7671 29.7544 29.9204 29.8566 29.9204 30.061V30.6741H29.7671V30.1121C29.7671 29.9588 29.6649 29.9077 29.5116 29.9077C29.3583 29.9077 29.205 30.0099 29.205 30.1631V30.6741H29.0518V29.7544Z",
    fill: "#7F8081"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7302 29.8564C32.6791 29.7031 32.577 29.5498 32.3215 29.5498C32.0149 29.5498 31.8616 29.7031 31.8616 30.0608C31.8616 30.3163 31.9638 30.5206 32.3215 30.5206C32.5259 30.5206 32.6791 30.4184 32.7302 30.163H32.9346C32.8835 30.4184 32.6792 30.6739 32.3215 30.6739C32.0149 30.6739 31.6572 30.5206 31.6572 30.0097C31.6572 29.652 31.8616 29.3455 32.3215 29.3455C32.577 29.3455 32.8835 29.4476 32.9346 29.8053H32.7302V29.8564Z",
    fill: "#7F8081"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2632 30.163C34.2121 30.2141 34.2121 30.2141 34.1099 30.2141H33.9055C33.7522 30.2141 33.7011 30.2652 33.7011 30.3674C33.7011 30.4696 33.8033 30.5206 33.9055 30.5206C34.1099 30.5206 34.2632 30.4185 34.2632 30.2652V30.163ZM33.5479 30.0097C33.5479 29.8053 33.7011 29.7031 34.0077 29.7031C34.2121 29.7031 34.4165 29.7542 34.4165 29.9586V30.4185C34.4165 30.4695 34.4165 30.5206 34.5187 30.5206H34.5698V30.6228C34.5187 30.6228 34.4676 30.6228 34.4165 30.6228C34.3143 30.6228 34.2632 30.6228 34.2632 30.5206C34.2121 30.6228 34.0077 30.6739 33.9055 30.6739C33.599 30.6739 33.5479 30.5206 33.5479 30.4185C33.5479 30.2652 33.65 30.163 33.9566 30.163H34.161C34.2632 30.163 34.3143 30.1119 34.3143 30.0608C34.3143 29.9586 34.2121 29.9075 34.0588 29.9075C33.9055 29.9075 33.8033 29.9586 33.8033 30.0608H33.5479V30.0097Z",
    fill: "#7F8081"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.234 29.4478H35.3873V29.7032H35.6428V29.8565H35.3873V30.4186C35.3873 30.4697 35.4384 30.5208 35.5406 30.5208C35.5917 30.5208 35.6428 30.5208 35.6428 30.5208V30.674C35.5917 30.674 35.5406 30.674 35.4384 30.674C35.2851 30.674 35.1829 30.5718 35.1829 30.4697V29.9076H34.9785V29.7543H35.1829V29.4478H35.234Z",
    fill: "#7F8081"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2559 29.3965H36.4092V29.8564C36.5114 29.7542 36.6135 29.7031 36.7668 29.7031C36.9712 29.7031 37.1245 29.8053 37.1245 30.0096V30.6228H36.9712V30.0607C36.9712 29.9074 36.869 29.8564 36.7157 29.8564C36.5624 29.8564 36.4092 29.9585 36.4092 30.1118V30.6228H36.2559V29.3965Z",
    fill: "#7F8081"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6063 30.1121C38.6063 29.9588 38.453 29.8566 38.2997 29.8566C38.1464 29.8566 37.9931 29.9588 37.9931 30.1121H38.6063ZM37.9931 30.2142C37.9931 30.4186 38.1464 30.5208 38.2997 30.5208C38.4019 30.5208 38.5552 30.4697 38.6063 30.3675H38.8106C38.7084 30.5719 38.5041 30.6741 38.3508 30.6741C37.9931 30.6741 37.8398 30.4697 37.8398 30.2142C37.8398 29.9588 37.9931 29.7544 38.3508 29.7544C38.6063 29.7544 38.8617 29.9077 38.8617 30.2653H37.9931V30.2142Z",
    fill: "#7F8081"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.526 29.4478H39.6793V29.7032H39.9347V29.8565H39.6793V30.4186C39.6793 30.4697 39.7304 30.5208 39.8325 30.5208C39.8836 30.5208 39.9347 30.5208 39.9347 30.5208V30.674C39.8836 30.674 39.8326 30.674 39.7304 30.674C39.5771 30.674 39.4749 30.5718 39.4749 30.4697V29.9076H39.2705V29.7543H39.4749V29.4478H39.526Z",
    fill: "#7F8081"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3654 30.1121C41.3654 29.9588 41.2121 29.8566 41.0588 29.8566C40.9055 29.8566 40.7522 29.9588 40.7522 30.1121H41.3654ZM40.7011 30.2142C40.7011 30.4186 40.8544 30.5208 41.0077 30.5208C41.1099 30.5208 41.2632 30.4697 41.3143 30.3675H41.5187C41.4165 30.5719 41.2121 30.6741 41.0588 30.6741C40.7011 30.6741 40.5479 30.4697 40.5479 30.2142C40.5479 29.9588 40.7011 29.7544 41.0588 29.7544C41.3143 29.7544 41.5698 29.9077 41.5698 30.2653H40.7011V30.2142Z",
    fill: "#7F8081"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1836 29.7542H42.3369V29.9075C42.4391 29.7542 42.5412 29.7031 42.6434 29.7031C42.6945 29.7031 42.6945 29.7031 42.7456 29.7031V29.9075C42.6945 29.9075 42.6945 29.9075 42.6434 29.9075C42.4901 29.9075 42.3369 30.0097 42.3369 30.2141V30.6739H42.1836V29.7542Z",
    fill: "#7F8081"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_881_2383",
    x1: 45.7765,
    y1: 30.1911,
    x2: 68.2559,
    y2: 30.1911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_881_2383",
    x1: 45.7392,
    y1: 30.3535,
    x2: 68.2278,
    y2: 30.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_881_2383",
    x1: 45.7645,
    y1: 31.3223,
    x2: 68.2613,
    y2: 31.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_881_2383",
    x1: 45.735,
    y1: 32.7183,
    x2: 68.3928,
    y2: 32.7183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_881_2383",
    x1: 45.7287,
    y1: 32.6651,
    x2: 68.3861,
    y2: 32.6651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_881_2383",
    x1: 45.7004,
    y1: 31.4666,
    x2: 68.3578,
    y2: 31.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_881_2383",
    x1: 45.7972,
    y1: 30.4338,
    x2: 68.3246,
    y2: 30.4338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_881_2383",
    x1: 45.7383,
    y1: 31.1652,
    x2: 68.3999,
    y2: 31.1652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_881_2383",
    x1: 45.8173,
    y1: 32.582,
    x2: 68.3512,
    y2: 32.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_881_2383",
    x1: 45.8021,
    y1: 31.2801,
    x2: 68.3403,
    y2: 31.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_881_2383",
    x1: 45.8014,
    y1: 28.5284,
    x2: 68.344,
    y2: 28.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.4174e01a10242d6285ae2c5e2821568c.svg";
export { ForwardRef as ReactComponent };